var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIron = function SvgIron(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1074",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.33 255.98h297.42c4.759 0 8.566 3.924 8.566 8.68v9.751c0 4.638-3.807 8.562-8.566 8.562H15.33c-4.64 0-8.566-3.924-8.566-8.562v-9.75c0-4.757 3.926-8.681 8.566-8.681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1076",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.446 246.94c34.263-99.647 132.89-173.25 265.66-169.92 14.395.713 24.27 10.107 28.077 21.285l31.884 112.96c2.141 8.086-.714 11.296-7.257 11.534-15.347.951-24.508 11.772-27.72 25.328zm256.62-133.65c3.45.238 5.473 2.497 6.424 6.421l19.154 70.038c1.547 5.113-1.07 8.8-6.78 8.918h-130.39c-27.245-1.189-38.428-42.332-7.734-58.385 41.52-19.858 81.256-28.419 119.33-26.993z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1078",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M216.62 161.57h17.726c11.778 0 21.533 9.75 21.533 21.523v5.47h-60.793v-5.47c0-11.772 9.755-21.523 21.533-21.523z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1080",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m89.686 106.63 11.183-7.848c7.376-5.232 17.845-3.449 23.08 4.043l2.38 3.33c-14.515 8.323-26.412 18.55-38.19 26.992l-2.379-3.33c-5.354-7.49-3.57-17.835 3.926-23.186z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIron);
export default ForwardRef;